import PropTypes from 'prop-types'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import MasonryGrid from './masonry-grid'

export default function MasonryGridWithData(props) {
  const {
    query, graphqlQuery, parentCollection, variables,
  } = props
  const QUERY = graphqlQuery
  const queryVariables = { ...query, ...variables }

  return (
    <Query query={QUERY} variables={queryVariables}>
      {({
        loading, error, data,
      }) => {
        if (error) {
          return <Error error={error} displayErrorType="component" />
        }
        if (loading) return <LinearProgress color="secondary" />
        const response = data && data[parentCollection] && data[parentCollection].items[0]

        return (
          <MasonryGrid {...props} {...response} />
        )
      }}
    </Query>
  )
}

MasonryGridWithData.propTypes = {
  query: PropTypes.object,
  graphqlQuery: PropTypes.object.isRequired,
  variables: PropTypes.object,
  parentCollection: PropTypes.string.isRequired,
}
